export function Alert({message}){
  return (
    <div>
      <span>{message}</span>
    </div>
  )
}
